import { ConnectUserType } from './appTypes'
import connectApi from '../api/connectApi'
import jwtDecode from 'jwt-decode'
import { constants, internetConnect } from 'helpers'
import i18n from './i18n'
import { sendMessageToWorker } from './communication'
import { AuthMethodEnum, AuthMethodType } from '../storeTypes'
import * as Sentry from '@sentry/react'

const LOGIN_ERROR_MESSAGES = {
    401: 'login.invalidCredentials',
    403: 'login.notAuthorized'
} as { [key: number]: string }

const saveAndGetUser = (token: string) => {
    const user: ConnectUserType = jwtDecode(token)
    user.token = token
    localStorage.setItem(constants.CONNECT_USER, JSON.stringify(user))
    sendMessageToWorker({ 'user info': user })
    return user
}

export const authenticateUser = async ({
    method,
    methodData
}: AuthMethodType) => {
    const isOnline = internetConnect()
    const { LOGIN, GOOGLE_LOGIN } = constants.endpoints
    const endpointToUse =
        method === AuthMethodEnum.PASSWORD ? LOGIN : GOOGLE_LOGIN

    try {
        const { data, status } = await connectApi.post(
            endpointToUse,
            methodData
        )

        if (status >= 400 || !data?.access_token) {
            let message = LOGIN_ERROR_MESSAGES[status] || 'login.notAuthorized'
            if (!isOnline) {
                message = 'noInternet'
            }

            return {
                message,
                statusCode: status >= 400 ? status : 403
            }
        }

        const user = saveAndGetUser(data.access_token)

        if (process.env.REACT_APP_SENTRY_DSN) {
            Sentry.setUser({
                id: user.user_id.toString(),
                username: user.username
            })
        }

        i18n.changeLanguage(user.language)

        return { message: data.message, statusCode: status, user }
    } catch (error) {
        const isOffline = !internetConnect()
        const message = isOffline ? 'noInternet' : 'login.invalidCredentials'
        const statusCode: number = isOffline ? 0 : 500

        const shouldReportToSentry = !isOffline && statusCode !== 401

        if (shouldReportToSentry) {
            Sentry.captureException(error)
        }

        return {
            message,
            statusCode
        }
    }
}
